import React from "react";
import ReactDOM from "react-dom/client";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";
import { ClerkProvider, SignedIn, SignedOut, SignInButton } from "@clerk/clerk-react";

import "./index.css";

import Layout from "./pages/layout/Layout";
import Chat from "./pages/chat/Chat";

var layout = <Layout />;

initializeIcons();

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

const router = createHashRouter([
    {
        path: "/",
        element: <Layout />,
        children: [
            {
                index: true,
                element: (
                    <>
                        <SignedIn>
                            <Chat />
                        </SignedIn>
                        <SignedOut>
                            <div className="landing-container">
                                <div className="animated-lines">
                                    <div className="line line-1"></div>
                                    <div className="line line-2"></div>
                                    <div className="line line-3"></div>
                                    <div className="line line-4"></div>
                                    <div className="line line-5"></div>
                                </div>
                                <div className="landing-content">
                                    <img src="/favicon.png" width={64} className="landing-logo" />
                                    <h1 className="landing-title">videntis</h1>
                                    <h2 className="landing-subtitle">Inicia sesi&oacute;n para continuar</h2>
                                    <SignInButton mode="modal">
                                        <button className="landing-button">
                                            Iniciar sesi&oacute;n
                                        </button>
                                    </SignInButton>
                                </div>
                            </div>
                        </SignedOut>
                    </>
                )
            },
            {
                path: "*",
                lazy: () => import("./pages/NoPage")
            }
        ]
    }
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <ClerkProvider publishableKey={clerkPubKey} afterSignOutUrl="/">
            <RouterProvider router={router} />
        </ClerkProvider>
    </React.StrictMode>
);
